import { useEffect } from 'react';
import { Container, Box } from '@mui/material';
import { Route, Routes, Navigate } from 'react-router-dom';
import { InProcessPage } from 'ui/pages/InProcess';
import { OrdersHistory } from 'ui/pages/OrdersHistory';
import { AdminShop } from 'ui/pages/Admin/AdminShop';
import { AdminMenu } from 'ui/pages/Admin/AdminMenu';
import { AdminPeople } from 'ui/pages/Admin/AdminPeople';
import { ShopAdminDrawer } from 'ui/components/common/AdminDrawer';
import { ShopAdminHeader } from 'ui/components/common/AdminHeader';
import { useAppSelector } from 'redux/hook';
import { Login } from 'ui/pages/Login';
import { Profile } from 'ui/pages/Profile';
import chaletApi from 'api/chaletApi';
import { Dashboard } from 'ui/pages/Dashboard';
import { Invoicing } from 'ui/pages/Admin/Invoicing';
import Feedbacks from 'ui/pages/Feedbacks/Feedbacks';
import BranchWallet from 'ui/pages/BranchWallet/BranchWallet';

export const AppRouter = () => {
  const { userId } = useAppSelector((state) => state.auth);
  const [getUserById] = chaletApi.useLazyGetUserByIdQuery();

  useEffect(() => {
    if (userId) {
      getUserById(userId);
    }
  }, [userId]);

  if (!userId) {
    return <Login />;
  }
  return (
    <Box>
      <ShopAdminHeader />
      <ShopAdminDrawer>
        <Container>
          <Routes>
            <Route path="/" element={<Navigate to="/inicio" replace />} />
            <Route path="/inicio" element={<Dashboard />} />
            <Route path="/billetera" element={<BranchWallet />} />
            <Route path="/en_proceso" element={<InProcessPage />} />
            <Route path="/ordenes" element={<OrdersHistory />} />
            <Route path="/feedbacks" element={<Feedbacks />} />
            <Route path="/admin/facturas-generadas" element={<Invoicing />} />
            <Route path="/admin/tienda" element={<AdminShop />} />
            <Route path="/admin/menu" element={<AdminMenu />} />
            <Route path="/admin/personal" element={<AdminPeople />} />
            <Route path="/perfil" element={<Profile />} />
            <Route path="*" element={<Navigate to="/inicio" replace />} />
          </Routes>
        </Container>
      </ShopAdminDrawer>
    </Box>
  );
};
